import styled from "styled-components";
import { gray100, gray300, gray700, gray900, white } from "core/resources/theme/colors";
import { WxDayItem } from "./types";
import { getWeatherIconSrc } from "./weatherIcons";

type Props = {
  days: WxDayItem[];
};

function formatRain(value: number | null) {
  if (value === null || value === undefined) return "-";
  return `${Number(value).toLocaleString("pt-BR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  })} mm`;
}

function WxDays({ days }: Props) {
  return (
    <Grid>
      {days.map((day) => {
        const iconSrc = day.iconSrc || (day.weatherKey ? getWeatherIconSrc(day.weatherKey) : undefined);
        return (
          <Day key={`${day.dayOfWeek}-${day.date}`}>
            <Dow>{day.dayOfWeek}</Dow>
            <DateLabel>{day.date}</DateLabel>
            {iconSrc ? <Icon src={iconSrc} alt="" /> : <IconPlaceholder />}
            <Rain>{formatRain(day.rainMm)}</Rain>
          </Day>
        );
      })}
    </Grid>
  );
}

export default WxDays;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 4px;
  min-width: 0;
`;

const Day = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 6px 2px 8px;
  border-radius: 8px;
  background: ${white};
  border: 1px solid ${gray300};
  text-align: center;
  min-width: 0;
`;

const Dow = styled.span`
  font-size: 0.66rem;
  font-weight: 700;
  color: ${gray700};
  text-transform: capitalize;
`;

const DateLabel = styled.span`
  font-size: 0.72rem;
  font-weight: 700;
  color: ${gray900};
`;

const Icon = styled.img`
  width: 45px;
  height: 45px;
  margin: 2px 0;
`;

const IconPlaceholder = styled.div`
  width: 28px;
  height: 28px;
  margin: 2px 0;
  border-radius: 50%;
  background: ${gray100};
`;

const Rain = styled.span`
  font-size: 0.7rem;
  font-weight: 700;
  color: ${gray900};
  white-space: nowrap;
`;
